var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useLayoutEffect, useState } from "react";
import Navigation from "./navigation";
import { siteConfigParser } from "../../helpers/siteConfigParser";
import { LoginButton } from "./loginButton";
import { SubscribeButton } from "./subscribeButton";
import { nanoid } from 'nanoid';
import ProfileIcon from "../../../images/profile.svg";
import { Link, NavLink, useLocation, useSearchParams, useNavigate } from "react-router-dom";
import pubsub from "@viewlift/pubsub";
import localforage from "localforage";
import { logout } from "../../MFEs/web-authentication-sdk/src/logic/login/logOut";
import { hamburgerIcon, closeIcon, searchIcon } from "../../../images/icon";
import "./index.scss";
import { Searchbox } from "../StandaloneSearch/Searchbox";
import { getTVProviderLogo, handleSeviceTypes, handleStatusGaCalls, isTveOnlyLoginEnabled, switchBetweenPages, tveSignOut } from "../../helpers";
import { getFontsStyles } from "../TrayModules/Helper/helper";
import { useStandaloneSearchHelper } from '../StandaloneSearch';
import "../VLFooterModule/index.scss";
import { ANALYTICS } from "../../helpers/analyticsMap";
import Cookies from 'js-cookie';
import ThumbnailDropdownMenu from "./ThumbnailDropdownMenu";
import AppStoreSuggestion from '../../components/AppStoreSuggestion';
import { publishVerticalMastheadStatus, subscribeVerticalMastheadStatus } from "../VerticalMasthead/verticalMasthead.event";
import { parseJSON } from "../../MFEs/Monetization-Sdk/src/helper";
import { logoutProfileAgainstMvpd } from "../../components/AdobeRestV2/Apis";
import { fetchUserObject } from "../../OnBoarding-V2/MonetisationModule02/Stripe/helper";
import { TveLoginButton } from "./subscribeButton/TveLoginButton";
import { publishInitiateTvePopup } from "../../components/AdobeRestV2/V2TveLogin/tve-login-events";
var IGNORED_ELEMENTS = ["searchIcon", "vl_recent_search_result", "vl_search_result_button", "vl_searchbox_input"];
export var Masthead = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41;
    var manageOverlayElement = useStandaloneSearchHelper().manageOverlayElement;
    var tveLoginOnly = isTveOnlyLoginEnabled();
    var _42 = __read(useSearchParams(), 1), searchParams = _42[0];
    var _43 = __read(useState(null), 2), mvpd = _43[0], setMvpd = _43[1];
    var pathname = useLocation().pathname;
    var _44 = __read(useState(null), 2), mvpdLogo = _44[0], setMvpdLogo = _44[1];
    var _45 = __read(useState(false), 2), showMasthead = _45[0], setShowMasthead = _45[1];
    var navigate = useNavigate();
    var _46 = __read(useState(parseInt(Cookies === null || Cookies === void 0 ? void 0 : Cookies.get('AppStoreSuggestion'), 10) || 0), 2), appStoreSuggestion = _46[0], setAppStoreSuggestion = _46[1];
    var _47 = __read(useState({
        user: {
            isSubscribed: false,
            userId: "",
            provider: "",
            tveUserId: ""
        },
    }), 2), access = _47[0], setAccess = _47[1];
    var _48 = __read(useState(false), 2), userMenu = _48[0], setUserMenu = _48[1];
    var _49 = __read(useState(false), 2), loading = _49[0], setLoading = _49[1];
    var _50 = __read(useState(false), 2), isToggle = _50[0], setIsToggle = _50[1];
    var siteConfig = (props && props.siteConfig) || {};
    var _51 = __read(useState([]), 2), navigationItems = _51[0], setNavigationItems = _51[1];
    var _52 = __read(useState({
        isUserLoggedIn: false,
        isUserSubscribed: false,
    }), 2), handleUserState = _52[0], setHandleUserState = _52[1];
    var _53 = __read(useState(false), 2), isAppAccessing = _53[0], setIsAppAccessing = _53[1];
    var desktopLogo = siteConfigParser((_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _a === void 0 ? void 0 : _a.images, "desktopLogo");
    var mobileLogo = siteConfigParser((_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.images, "mobileLogo");
    var changeAccess = function (data) {
        setAccess(data);
    };
    var navigationSettings = window.app_data.appcmsPlatform.navigation.user;
    var currentYear = new Date().getFullYear();
    var companyName = ((_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsMain) === null || _d === void 0 ? void 0 : _d.companyName) || "";
    var allRightReservedText = ((_g = (_f = (_e = window === null || window === void 0 ? void 0 : window.app_data) === null || _e === void 0 ? void 0 : _e.appcmsMain) === null || _f === void 0 ? void 0 : _f.genericMessages) === null || _g === void 0 ? void 0 : _g.copyrightText) || "ALL RIGHTS RESERVED.";
    var copyrightContent = ((_k = (_j = (_h = window === null || window === void 0 ? void 0 : window.app_data) === null || _h === void 0 ? void 0 : _h.appcmsMain) === null || _j === void 0 ? void 0 : _j.genericMessages) === null || _k === void 0 ? void 0 : _k.completeCopyrightText) || "\u00A9 ".concat(currentYear, " ").concat(companyName, " ").concat(allRightReservedText);
    var _54 = __read(useState(pathname.includes("/search")), 2), showSearchbox = _54[0], setShowSearchbox = _54[1];
    var navigationFonts = getFontsStyles((_m = (_l = props === null || props === void 0 ? void 0 : props.moduleData) === null || _l === void 0 ? void 0 : _l.layout) === null || _m === void 0 ? void 0 : _m.fontSetting, (_p = (_o = props === null || props === void 0 ? void 0 : props.moduleData) === null || _o === void 0 ? void 0 : _o.layout) === null || _p === void 0 ? void 0 : _p.settings).navigationFonts;
    var allowBothSvodTveActivation = (_r = (_q = window === null || window === void 0 ? void 0 : window.app_data.appcmsMain) === null || _q === void 0 ? void 0 : _q.monetizationConfig) === null || _r === void 0 ? void 0 : _r.allowBothSvodTveActivation;
    var sponserLogo = (_u = (_t = (_s = props === null || props === void 0 ? void 0 : props.moduleData) === null || _s === void 0 ? void 0 : _s.layout) === null || _t === void 0 ? void 0 : _t.settings) === null || _u === void 0 ? void 0 : _u.sponsorLogo;
    var navigationPlacement = ((_x = (_w = (_v = props === null || props === void 0 ? void 0 : props.moduleData) === null || _v === void 0 ? void 0 : _v.layout) === null || _w === void 0 ? void 0 : _w.settings) === null || _x === void 0 ? void 0 : _x.navigationPlacement) || 'Top';
    var searchConfig = (_0 = (_z = (_y = window === null || window === void 0 ? void 0 : window.app_data) === null || _y === void 0 ? void 0 : _y.appcmsMain) === null || _z === void 0 ? void 0 : _z.searchConfig) !== null && _0 !== void 0 ? _0 : null;
    var adobeVersion = ((_3 = (_2 = (_1 = window === null || window === void 0 ? void 0 : window.app_data) === null || _1 === void 0 ? void 0 : _1.appcmsPlatform) === null || _2 === void 0 ? void 0 : _2.tveSettings) === null || _3 === void 0 ? void 0 : _3.version) || "v1";
    var selectedMvpdId = localStorage.getItem('selectedMvpdId');
    function getQueryParams(qs) {
        var _a;
        var paramString = (qs === null || qs === void 0 ? void 0 : qs.split('?').length) > 0 ? qs === null || qs === void 0 ? void 0 : qs.split('?')[1] : null;
        if (paramString) {
            var params_arr = paramString.split('&') || [paramString];
            for (var i = 0; i < params_arr.length; i++) {
                var pair = (_a = params_arr[i]) === null || _a === void 0 ? void 0 : _a.split('=');
                if (pair.includes('app'))
                    setIsAppAccessing(true);
            }
        }
    }
    var appAccessEnabler = function () {
        getQueryParams(window.location.href);
    };
    var checkToShow = function (navigation, store) { return __awaiter(void 0, void 0, void 0, function () {
        var AuthenticationStore, user, isSubscribed, isTveLoggedIn, navList, i, isToShow;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    AuthenticationStore = store;
                    if (!!store) return [3 /*break*/, 2];
                    return [4 /*yield*/, localforage.getItem('AuthenticationStore')];
                case 1:
                    AuthenticationStore = _p.sent();
                    _p.label = 2;
                case 2:
                    user = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
                    isSubscribed = (user === null || user === void 0 ? void 0 : user.isSubscribed) || false;
                    isTveLoggedIn = ((_a = user === null || user === void 0 ? void 0 : user.tveMetadata) === null || _a === void 0 ? void 0 : _a.tveProvider) ? true : false;
                    navList = [];
                    for (i = 0; i < navigation.length; i++) {
                        isToShow = false;
                        if (user && !isToShow) { //if logged in
                            if (isSubscribed && isTveLoggedIn) {
                                isToShow = ((_c = (_b = navigation[i]) === null || _b === void 0 ? void 0 : _b.accessLevels) === null || _c === void 0 ? void 0 : _c.subscribed) || ((_e = (_d = navigation[i]) === null || _d === void 0 ? void 0 : _d.accessLevels) === null || _e === void 0 ? void 0 : _e.tve);
                            }
                            else if (isTveLoggedIn && !isSubscribed && !isToShow) {
                                isToShow = ((_g = (_f = navigation[i]) === null || _f === void 0 ? void 0 : _f.accessLevels) === null || _g === void 0 ? void 0 : _g.tve) ? true : false;
                            }
                            else if (!isTveLoggedIn && isSubscribed && !isToShow) {
                                isToShow = ((_j = (_h = navigation[i]) === null || _h === void 0 ? void 0 : _h.accessLevels) === null || _j === void 0 ? void 0 : _j.subscribed) ? true : false;
                            }
                            else {
                                isToShow = ((_l = (_k = navigation[i]) === null || _k === void 0 ? void 0 : _k.accessLevels) === null || _l === void 0 ? void 0 : _l.loggedIn) ? true : false;
                            }
                        }
                        else {
                            isToShow = ((_o = (_m = navigation[i]) === null || _m === void 0 ? void 0 : _m.accessLevels) === null || _o === void 0 ? void 0 : _o.loggedOut) ? true : false;
                        }
                        if (isToShow) {
                            navList.push(navigation[i]);
                        }
                    }
                    return [2 /*return*/, navList];
            }
        });
    }); };
    useLayoutEffect(function () {
        handleUserLoggedState();
    }, []);
    var handleVerticalNavigation = function (status) {
        setShowMasthead(status);
    };
    var updateAccess = function (data) {
        if (data) {
            setTimeout(function () {
                localforage
                    .getItem("AuthenticationStore")
                    .then(function (store) {
                    if (store && typeof store.user == "object") {
                        if ('isSubscribed' in (store === null || store === void 0 ? void 0 : store.user)) {
                            checkToShow(navigationSettings, store).then(function (navList) {
                                console.log("navsafdsaf", navList);
                                setNavigationItems(navList);
                            });
                        }
                        setAccess(store);
                    }
                    ;
                });
            }, 100);
        }
    };
    useEffect(function () {
        var handleHeaderPosition = function () {
            if (window.innerWidth <= 1200) {
                publishVerticalMastheadStatus(false);
            }
            else if (navigationPlacement === 'Left') {
                publishVerticalMastheadStatus(true);
            }
            else {
                publishVerticalMastheadStatus(false);
            }
        };
        subscribeVerticalMastheadStatus(handleVerticalNavigation);
        handleHeaderPosition();
        localforage
            .getItem("AuthenticationStore")
            .then(function (store) {
            var _a, _b, _c, _d;
            if (store && typeof store.user == "object")
                setAccess(store);
            if (store && ((_b = (_a = store === null || store === void 0 ? void 0 : store.user) === null || _a === void 0 ? void 0 : _a.tveMetadata) === null || _b === void 0 ? void 0 : _b.mvpdProvider)) {
                var mvpd_1 = (_d = (_c = store === null || store === void 0 ? void 0 : store.user) === null || _c === void 0 ? void 0 : _c.tveMetadata) === null || _d === void 0 ? void 0 : _d.mvpdProvider;
                setMvpd(mvpd_1);
                setMvpdLogo(getTVProviderLogo(mvpd_1));
            }
            checkToShow(navigationSettings, store).then(function (navList) {
                setNavigationItems(navList);
            });
        })
            .catch(function (err) {
            console.log(err);
            return;
        });
        appAccessEnabler();
        // after login or subscription to handle race condition
        pubsub.subscribe("update-user-state", updateAccess);
        // handleUserLoggedState();
    }, []);
    var getBackgroundColor = function () {
        var _a, _b, _c, _d;
        var bgColor = (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.siteConfig) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.brand) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.backgroundColor;
        return isAppAccessing ? { backgroundColor: bgColor, display: 'none' } : { backgroundColor: bgColor };
    };
    var fireLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var user, isTveLoggedIn;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetchUserObject()];
                case 1:
                    user = _b.sent();
                    isTveLoggedIn = (user === null || user === void 0 ? void 0 : user.tveProvider) || ((_a = user === null || user === void 0 ? void 0 : user.tveMetadata) === null || _a === void 0 ? void 0 : _a.tveProvider);
                    if (!(adobeVersion == 'v2' && isTveLoggedIn)) return [3 /*break*/, 4];
                    return [4 /*yield*/, tveSignOut()];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, logoutProfileAgainstMvpd(selectedMvpdId)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    logout()
                        .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            console.log(res.data);
                            localforage.clear();
                            localStorage.removeItem('dismissSplash');
                            Cookies.remove('userStateToken');
                            localStorage.removeItem('pageRefreshStatus');
                            localStorage.removeItem('hidePersonalizationBanner');
                            pubsub.publish('dispose-cookies', 'token');
                            pubsub.publish('apploading', false);
                            pubsub.publish('user-analytics', { ename: ANALYTICS.LOGOUT });
                            adobeVersion == 'v1' && window && (window === null || window === void 0 ? void 0 : window.AE) && ((_a = window.AE) === null || _a === void 0 ? void 0 : _a.logout());
                            handleStatusGaCalls({ eventName: 'logout', subSection: null, type: 'logout', reason: null, status: null, action: 'Logout', paymentStatus: null, eventCategory: 'Authentication', section: null, additionalLabel: null });
                            window.location.assign("/");
                            return [2 /*return*/, res.data];
                        });
                    }); })
                        .catch(function (e) {
                        console.error(e);
                        pubsub.publish('apploading', false);
                        return e;
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUserLoggedState = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginState;
        return __generator(this, function (_a) {
            loginState = localStorage.getItem("loginState");
            setHandleUserState(parseJSON(loginState));
            return [2 /*return*/];
        });
    }); };
    pubsub.subscribe("AuthenticationStore", changeAccess);
    var handleLoader = function () {
        setLoading(true);
        pubsub.publish('apploading', true);
    };
    var toggleImg = function () {
        (isToggle == false ? setIsToggle(true) : setIsToggle(false));
        var bodyTag = document.getElementsByTagName("body");
        if (!isToggle) {
            bodyTag[0].style.overflow = "hidden";
            // bodyTag[0].style.position = "relative"
            bodyTag[0].style.position = "fixed";
        }
        else {
            bodyTag[0].style.overflow = "unset";
            bodyTag[0].style.position = "unset";
        }
    };
    var handleAppStoreSuggestion = function (data) {
        setAppStoreSuggestion(data);
    };
    useEffect(function () {
        pubsub.subscribe("appStoreSuggestionData", handleAppStoreSuggestion);
        document.addEventListener("click", function (e) {
            var clickedElement = e.target;
            if (IGNORED_ELEMENTS.includes(clickedElement.id))
                return;
            var searchboxElement = document.getElementById("searchboxWrapper");
            if (searchboxElement === null || searchboxElement === void 0 ? void 0 : searchboxElement.contains(clickedElement))
                return;
            setShowSearchbox(false);
            manageOverlayElement([
                { actionType: "hide", elementId: "searchResultContainer" },
                { actionType: "hide", elementId: "wrapperOverlay" },
            ]);
        });
        document.addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
                setShowSearchbox(true);
                manageOverlayElement([
                    { actionType: "hide", elementId: "searchResultContainer" },
                    { actionType: "hide", elementId: "wrapperOverlay" },
                ]);
            }
        });
        return function () {
            pubsub.unsubscribe("appStoreSuggestionData");
        };
    }, []);
    desktopLogo ? desktopLogo + 'impolicy=resize&w=640&h=360' : null;
    mobileLogo ? mobileLogo + 'impolicy=resize&w=512&h=512' : null;
    var serviceTypes = handleSeviceTypes();
    var thumbnailType = ((_6 = (_5 = (_4 = window === null || window === void 0 ? void 0 : window.app_data) === null || _4 === void 0 ? void 0 : _4.appcmsMain) === null || _5 === void 0 ? void 0 : _5.navigationConfig) === null || _6 === void 0 ? void 0 : _6.dropdownNavigationType) || "STANDARD";
    var appSuggestionFlag = (((_9 = (_8 = (_7 = window === null || window === void 0 ? void 0 : window.app_data) === null || _7 === void 0 ? void 0 : _7.appcmsMain) === null || _8 === void 0 ? void 0 : _8.features) === null || _9 === void 0 ? void 0 : _9.app_download_suggestion) && (((_12 = (_11 = (_10 = window === null || window === void 0 ? void 0 : window.app_data) === null || _10 === void 0 ? void 0 : _10.appcmsMain) === null || _11 === void 0 ? void 0 : _11.features) === null || _12 === void 0 ? void 0 : _12.google_playstore_url) || ((_15 = (_14 = (_13 = window === null || window === void 0 ? void 0 : window.app_data) === null || _13 === void 0 ? void 0 : _13.appcmsMain) === null || _14 === void 0 ? void 0 : _14.features) === null || _15 === void 0 ? void 0 : _15.itunes_store_url))) || null;
    function checkForSvod() {
        var _a, _b;
        if (allowBothSvodTveActivation) {
            return (!access.user.isSubscribed && (serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.SVOD) && (((_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.monetisationModelByCountry) === "SVOD"));
        }
        return (!access.user.isSubscribed && !access.user.tveUserId && (serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.SVOD) && (((_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.monetisationModelByCountry) === "SVOD"));
    }
    return (React.createElement(React.Fragment, null,
        " ",
        !showMasthead && React.createElement(React.Fragment, null,
            (!isAppAccessing && appSuggestionFlag && !(window.location.href.indexOf("embed/player") > -1)) && React.createElement(AppStoreSuggestion, null),
            (isAppAccessing) ? React.createElement(React.Fragment, null) :
                React.createElement("div", null,
                    React.createElement("div", { className: "sudo-header" }),
                    React.createElement("header", { className: "header-container", style: __assign(__assign({}, getBackgroundColor()), navigationFonts) },
                        React.createElement("div", { tabIndex: 0, className: "logo-image" }, desktopLogo && React.createElement(Link, { to: "/", onKeyDown: function (e) {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    switchBetweenPages();
                                }
                            }, onClick: function () { return switchBetweenPages(); } },
                            React.createElement("img", { role: "banner", src: desktopLogo, alt: "Site Logo" }))),
                        sponserLogo && React.createElement("div", { className: "logo-image sponser" },
                            React.createElement(NavLink, { to: (_19 = (_18 = (_17 = (_16 = window === null || window === void 0 ? void 0 : window.app_data) === null || _16 === void 0 ? void 0 : _16.appcmsMain) === null || _17 === void 0 ? void 0 : _17.socialMedia) === null || _18 === void 0 ? void 0 : _18.ticketMaster) === null || _19 === void 0 ? void 0 : _19.url, target: "_blank", referrerPolicy: "no-referrer" },
                                React.createElement("img", { height: 34, width: 62, src: sponserLogo, alt: "Logo" }))),
                        React.createElement(Navigation, { checkToShow: checkToShow, isMobile: false, navigation: siteConfigParser(siteConfig.appcmsPlatform, "navigation"), brand: siteConfigParser(siteConfig.appcmsMain.brand, "navigation"), navigationItems: navigationItems }),
                        (searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.isEnabled) ? React.createElement("div", { tabIndex: 0, id: 'searchboxWrapper', className: "".concat(showSearchbox ? "Searchbox-wrapper" : "Searchbox-wrapper-fit") },
                            React.createElement(Searchbox, { visible: showSearchbox, manageVisibility: setShowSearchbox, placeholder: (_20 = props.siteConfig.appcmsMain.genericMessages.emptySearchField) !== null && _20 !== void 0 ? _20 : "Search...", genericMessages: props.siteConfig.appcmsMain.genericMessages, showSearchbar: false })) : null,
                        access.user.userId === "" && !tveLoginOnly && React.createElement(LoginButton, { handleLoader: handleLoader, layoutSettings: (_21 = props === null || props === void 0 ? void 0 : props.moduleData) === null || _21 === void 0 ? void 0 : _21.layout, dataTest: "login-btn" }),
                        (searchParams.get("device") !== "roku_box" && checkForSvod() && !tveLoginOnly) && (React.createElement(SubscribeButton, { handleLoader: handleLoader, layoutSettings: (_22 = props === null || props === void 0 ? void 0 : props.moduleData) === null || _22 === void 0 ? void 0 : _22.layout, dataTest: "subscribe-btn" })),
                        tveLoginOnly && !mvpd ? React.createElement(TveLoginButton, { handleLoader: function () { return publishInitiateTvePopup(true); }, layoutSettings: (_23 = props === null || props === void 0 ? void 0 : props.moduleData) === null || _23 === void 0 ? void 0 : _23.layout, dataTest: "tve-btn" }) : null,
                        access.user.userId && (React.createElement("div", { tabIndex: 0, onKeyDown: function (e) {
                                if (e.key === "Tab") {
                                    setUserMenu(true);
                                }
                                else if (e.key === "Escape") {
                                    setUserMenu(false);
                                }
                            }, onMouseEnter: function () { return setUserMenu(true); }, onMouseLeave: function () { return setUserMenu(false); } },
                            React.createElement("div", { className: "profileIcon" },
                                React.createElement(ProfileIcon, null)),
                            React.createElement("div", { "aria-haspopup": "menu", className: "userMenu ".concat(userMenu ? "open" : "close") },
                                navigationItems.map(function (item) {
                                    item.title === "Log In" ? navigationSettings.pop() : navigationSettings;
                                    return (React.createElement("div", { key: nanoid() },
                                        React.createElement(Link, { "aria-label": item.title, onKeyDown: function (e) {
                                                // Handle both Enter and Space for accessibility
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    // Programmatically trigger click event
                                                    var targetElement = e.currentTarget;
                                                    targetElement.click();
                                                }
                                            }, role: "link", className: "navigation-link-dropDown", to: item.url }, item.title)));
                                }),
                                React.createElement("div", { tabIndex: 0, className: "navigation-link-dropDown", onKeyDown: function (e) {
                                        // Handle both Enter and Space for accessibility
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            fireLogout();
                                        }
                                    }, onClick: function () { return fireLogout(); } },
                                    React.createElement("span", { style: { padding: "5px" } }, ((_28 = (_27 = (_26 = (_25 = (_24 = window === null || window === void 0 ? void 0 : window.app_data) === null || _24 === void 0 ? void 0 : _24.appcmsPlatform) === null || _25 === void 0 ? void 0 : _25.navigation) === null || _26 === void 0 ? void 0 : _26.settings) === null || _27 === void 0 ? void 0 : _27.primaryCta) === null || _28 === void 0 ? void 0 : _28.logoutCtaText) || "Log Out"))))),
                        mvpd && mvpdLogo &&
                            React.createElement("div", { className: "tve-provider-logo" },
                                React.createElement("img", { src: mvpdLogo, alt: "Provider Logo" }))),
                    thumbnailType === "THUMBNAIL" ? React.createElement(ThumbnailDropdownMenu, { navigationFonts: navigationFonts }) : React.createElement(React.Fragment, null),
                    React.createElement("div", { className: "hamburger-container" },
                        React.createElement("div", { className: 'hamburger-wrapper hamburger-wrapper-pos-relative', style: __assign(__assign({}, getBackgroundColor()), navigationFonts) },
                            React.createElement("div", { tabIndex: 0, className: "toogle-img", onKeyDown: function (e) {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        toggleImg();
                                    }
                                }, onClick: function () { return toggleImg(); } }, isToggle == false ? hamburgerIcon() : closeIcon()),
                            React.createElement("div", { className: "nav-links ".concat(isToggle ? "active" : "", " ").concat(appSuggestionFlag && appStoreSuggestion !== 1 ? "app-suggestion" : "") },
                                React.createElement(Navigation, { checkToShow: checkToShow, isMobile: false, navigation: siteConfigParser(siteConfig.appcmsPlatform, "navigation"), brand: siteConfigParser(siteConfig.appcmsMain.brand, "navigation"), navigationItems: navigationItems }),
                                React.createElement("div", { className: "bottom-container" },
                                    access.user.userId === "" && (React.createElement(LoginButton, { handleLoader: handleLoader, layoutSettings: (_29 = props === null || props === void 0 ? void 0 : props.moduleData) === null || _29 === void 0 ? void 0 : _29.layout })),
                                    ((_30 = access === null || access === void 0 ? void 0 : access.user) === null || _30 === void 0 ? void 0 : _30.tveUserId) && tveLoginOnly ?
                                        React.createElement("button", { className: "log-out-cta subscribeBtn site-cta-background-color site-cta-color", onClick: function () { return fireLogout(); } }, ((_35 = (_34 = (_33 = (_32 = (_31 = window === null || window === void 0 ? void 0 : window.app_data) === null || _31 === void 0 ? void 0 : _31.appcmsPlatform) === null || _32 === void 0 ? void 0 : _32.navigation) === null || _33 === void 0 ? void 0 : _33.settings) === null || _34 === void 0 ? void 0 : _34.primaryCta) === null || _35 === void 0 ? void 0 : _35.logoutCtaText) || 'Logout') : null,
                                    (searchParams.get("device") !== "roku_box" && checkForSvod()) && (React.createElement(SubscribeButton, { handleLoader: handleLoader, layoutSettings: (_36 = props === null || props === void 0 ? void 0 : props.moduleData) === null || _36 === void 0 ? void 0 : _36.layout })),
                                    React.createElement("div", { className: "vl_footer_row vl_footer_row_bottom" },
                                        React.createElement("div", { className: "copy_right_container", dangerouslySetInnerHTML: { __html: copyrightContent } }),
                                        ((_39 = (_38 = (_37 = window === null || window === void 0 ? void 0 : window.app_data) === null || _37 === void 0 ? void 0 : _37.appcmsPlatform) === null || _38 === void 0 ? void 0 : _38.navigation) === null || _39 === void 0 ? void 0 : _39.footer) ? React.createElement("div", { className: "vl_footer_row_info" }, (_40 = window === null || window === void 0 ? void 0 : window.app_data) === null || _40 === void 0 ? void 0 : _40.appcmsPlatform.navigation.footer.map(function (link) { return (React.createElement(NavLink, { key: link.url, onClick: function () {
                                                pubsub.publish('apploading', true);
                                            }, to: link.url }, link.title)); })) : React.createElement(React.Fragment, null)))),
                            React.createElement("div", { className: "logo-image" },
                                React.createElement("div", { className: "site-logo-image" }, mobileLogo && React.createElement(Link, { to: "/", onClick: function () { return switchBetweenPages(); } },
                                    React.createElement("img", { src: mobileLogo, alt: "Logo" })))),
                            React.createElement("div", { className: "mobile-search-logo-wrapper" },
                                (searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.isEnabled) ? React.createElement("div", { className: "searchIcon" }, pathname.includes("/search") ? React.createElement(Searchbox, { visible: showSearchbox, manageVisibility: setShowSearchbox, placeholder: (_41 = props.siteConfig.appcmsMain.genericMessages.emptySearchField) !== null && _41 !== void 0 ? _41 : "Search...", genericMessages: props.siteConfig.appcmsMain.genericMessages, showSearchbar: false }) :
                                    React.createElement(Link, { tabIndex: 0, to: "/search", onKeyDown: function (e) {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                switchBetweenPages();
                                                navigate("/search");
                                            }
                                        }, onClick: function () { return switchBetweenPages(); } }, searchIcon())) : null,
                                mvpd && mvpdLogo &&
                                    React.createElement("div", { className: "tve-provider-logo" },
                                        React.createElement("img", { src: mvpdLogo, alt: "Provider Logo" })))))))));
};
